import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@nano/core/auth';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    window.addEventListener('pageshow', this.onPageShow);
  }

  ngOnDestroy(): void {
    window.removeEventListener('pageshow', this.onPageShow);
  }

  private onPageShow = (event: PageTransitionEvent): void => {
    if (event.persisted && !this.authService.isAuthorized()) {
      window.location.reload();
    }
  };
}
